export default "<router-outlet></router-outlet>\r\n<title>Simulador de autoproducci�n del RUV - Contenedor de tabs</title>"